import {inject, Injectable} from '@angular/core';
import {CartStore, CartState} from '@features/sales/application/store/cart/cart.store';
import {Cart} from '@features/sales/domain/entities/cart/cart.entity';

@Injectable({providedIn: 'root'})
export class CartQueryService {
  private readonly cart = inject(CartStore);

  snapshot(): CartState {
    return this.cart.state();
  }

  asEntity(): Cart {
    return new Cart(this.cart.state().items);
  }

  isEmpty(): boolean {
    return this.cart.state().items.length === 0;
  }
}
